module.exports = __webpack_public_path__ + "img/seguridad-icon.d70d9ae4.png";